import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Checkbox, Collapse, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { useState } from "react";

interface ReportAcknowledgmentSectionProps {
  workerFirstName?: string;
  acknowledged: boolean;
  onAcknowledgedChange: (acknowledged: boolean) => void;
}

export function ReportAcknowledgmentSection(props: ReportAcknowledgmentSectionProps) {
  const { workerFirstName, acknowledged, onAcknowledgedChange } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.background?.warning,
        border: `1px solid ${theme.palette.border?.warning}`,
        borderRadius: theme.borderRadius?.xLarge,
        padding: 4,
        marginBottom: 4,
      })}
    >
      <Stack direction="row" alignItems="flex-start" spacing={2}>
        <Checkbox
          checked={acknowledged}
          size="small"
          sx={{ padding: 0, marginTop: 0.25 }}
          onChange={(event) => onAcknowledgedChange(event.target.checked)}
        />
        <Box sx={{ flex: 1 }}>
          <Stack
            component="button"
            type="button"
            direction="row"
            alignItems="flex-start"
            justifyContent="space-between"
            sx={{
              width: "100%",
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
              textAlign: "left",
              gap: 1,
            }}
            onClick={() => setIsExpanded((previous) => !previous)}
          >
            <Text variant="body2" sx={{ color: "warning.dark" }}>
              I understand that submitting this report may result in{" "}
              <strong>{workerFirstName ?? "the professional"}</strong> being removed from the shift,
              and if applicable, penalties being applied to their account.
            </Text>
            <ExpandMoreIcon
              fontSize="small"
              sx={(theme) => ({
                color: theme.palette.warning.dark,
                flexShrink: 0,
                marginTop: 0.25,
                transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease-in-out",
              })}
            />
          </Stack>
          <Collapse in={isExpanded}>
            <Text
              variant="body2"
              sx={(theme) => ({
                color: theme.palette.text.secondary,
                marginTop: 2,
              })}
            >
              Our team will review the report and take necessary action, which may include removing
              the professional from the shift and applying penalties to their account. Your name and
              information will be included in this report and our team may reach out for additional
              context.
            </Text>
          </Collapse>
        </Box>
      </Stack>
    </Box>
  );
}
